import React from "react";
import Plot from "react-plotly.js";

const PracticumScoreChart = ({ id, title = "Id will go here", data }) => {
  const xValues = [];
  const yValues = [];
  const tooltips = [];

  data.forEach((entry, index) => {
    const score = entry.score;
    const maxScore = entry.max_score;
    const percentage = (score / maxScore) * 100;
    const date = new Date(parseInt(entry.datetime));

    xValues.push(index + 1);
    yValues.push(percentage);
    tooltips.push(
      `Date: ${date.toLocaleString()}<br>Score: ${percentage.toFixed(1)}%`
    );
  });

  return (
    <div className="practicum-score-modal">
      <Plot
        data={[
          {
            x: xValues,
            y: yValues,
            type: "bar",
            marker: { color: "#6b1f8f" },
            text: tooltips,
            hoverinfo: "text", // Show tooltip on hover only
            hoverlabel: { bgcolor: "#6b1f8f", font: { color: "#ffffff" } },
            // hide text on the top of the bars
            textposition: "none",
            showlegend: false,
          },
        ]}
        config={{
          displayModeBar: false,
          scrollZoom: false,
          // autosize: true,
          responsive: false,

          doubleClick: false,
          transition: {
            duration: 50,
            easing: "cubic-in-out",
          },
        }}
        layout={{
          plot_bgcolor: "#ffffff",
          paper_bgcolor: "#ffffff",
          bargap: 0.1,
          xaxis: {
            showgrid: false,
            showticklabels: false,
            range: [0.5, 10],
            zeroline: true,
          },
          yaxis: {
            title: "Score (%)",
            tickcolor: "#000000",
            range: [0, 100],
            showgrid: true,
            gridcolor: "rgba(0,0,0,0.1)",
            ticks: "outside",
          },
          margin: { l: 50, r: 30, t: 30, b: 30 },
        }}
        style={{ width: "100%", height: "400px" }}
      />
      <style jsx>{`
        .practicum-score-modal {
          font-family: Arial, sans-serif;
          background-color: white;
          border-radius: 4px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border: 1px solid #ccc;
        }
      `}</style>
    </div>
  );
};

export default PracticumScoreChart;
